import { render } from "./FullView.vue?vue&type=template&id=645ce2b7&scoped=true"
import script from "./FullView.vue?vue&type=script&lang=js"
export * from "./FullView.vue?vue&type=script&lang=js"

import "./FullView.vue?vue&type=style&index=0&id=645ce2b7&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645ce2b7"]])

export default __exports__